module.exports = __webpack_public_path__ + "img/service-volumes.d1465626.png";